import { render, staticRenderFns } from "./plGoodsStatement.vue?vue&type=template&id=1457bc47&scoped=true"
import script from "./plGoodsStatement.vue?vue&type=script&lang=js"
export * from "./plGoodsStatement.vue?vue&type=script&lang=js"
import style0 from "./plGoodsStatement.vue?vue&type=style&index=0&id=1457bc47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1457bc47",
  null
  
)

export default component.exports